import { merchantApi } from '@/config/axios';

/**
 * 商家管理中心 — 认证 API
 */

// 商家登录
export function merchantLogin(data: { username: string; password: string }) {
  return merchantApi.post({ url: '/merchant-api/auth/login', data });
}

// 商家登出
export function merchantLogout() {
  return merchantApi.post({ url: '/merchant-api/auth/logout' });
}

// 获取当前商家信息
export function getMerchantInfo() {
  return merchantApi.get({ url: '/merchant-api/auth/info' });
}

// 刷新Token
export function refreshMerchantToken(refreshToken: string) {
  return merchantApi.post({ url: '/merchant-api/auth/refresh-token', params: { refreshToken } });
}
